import { Box, Typography } from '@mui/material';
import { saveAs } from 'file-saver';
import { useTranslation } from 'react-i18next';
import { ReminderHighlight } from 'src/components/atoms/reminder-highlight';
import { DialogActions } from 'src/components/molecules/dialog';
import UploadDialog from 'src/components/organisms/upload-dialog';
import { useUploadSpaces } from 'src/features/spaces/api/hooks/use-upload-spaces';
import { spaceTypesTranslations } from 'src/features/spaces/constants/space-types-translations';

export const UploadSpacesDialog = ({ open, onCancel }: DialogActions) => {
  const { t } = useTranslation(['spaces']);

  const { mutateAsync: uploadSpaces } = useUploadSpaces(onCancel);

  const handleDownloadTemplate = () => {
    saveAs(
      '/static/upload-spaces-template.xlsx',
      'upload-spaces-template.xlsx',
    );
  };

  return (
    <UploadDialog
      title={t('spaces:common.uploadSpacesDialog.title')}
      templateId="spaces_download_template_button"
      importId="spaces_import_button"
      handleDownload={handleDownloadTemplate}
      open={open}
      onCancel={onCancel}
      onSubmit={file => uploadSpaces(file)}
      message={
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 2 }}>
          <ReminderHighlight
            variant="warning"
            title={t('spaces:common.uploadSpacesDialog.hint.title')}>
            <Typography variant="body2">
              {t('spaces:common.uploadSpacesDialog.hint.description', {
                types: Object.values(spaceTypesTranslations)
                  .map(key => t(key).toLowerCase())
                  .join(', '),
              })}
            </Typography>
          </ReminderHighlight>

          <Typography sx={{ mb: 2 }}>
            {t('spaces:common.uploadSpacesDialog.message')}
          </Typography>
        </Box>
      }
    />
  );
};
